import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import "./NextSteps.css";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useWebSocket } from "../../../uiUtils/useWebSocket";
import { fetchNextStepCardRequest } from "../../../../../store/features/actions/opportunities/nextStepCardActions";
import { ValueSellingFrameworkPlaceholder } from "./ValueSellingFramworkPlaceholder";
import NoDataComp from "../../../genericComponents/uiElements/NoDataComp";
import { useTaskStatus } from "../../../../../context/TaskStatusContext";
import GeneratingLoader from "../../../genericComponents/uiElements/GeneratingLoader";

export default function NextSteps({opportunityId }) {
  const dispatch = useDispatch();
  const [status, setStatus] = useState("Processing...");
  const [result, setResult] = useState(null);
  const { clientName, accountName } = useParams();
  const { nextStepCardData, nextStepCardLoading, error } = useSelector(
    (state) => state?.nextStepCardReducer
  );

  const { getTaskStatus } = useTaskStatus();
  const taskStatus = getTaskStatus(`opp_sidecard_next_step_${opportunityId}`);

  useEffect(() => {
    if (taskStatus=="completed") {
      if (opportunityId) {
        dispatch(
          fetchNextStepCardRequest({
            opportunityId
          })
        );
      }
    }
  }, [taskStatus])

  useEffect(() => {
    if (opportunityId) {
      dispatch(
        fetchNextStepCardRequest({
          opportunityId
        })
      );
    }
  }, [opportunityId]);

  useEffect(() => {
    if (error) {
      setStatus("Error loading data");
    }else{
      setResult(nextStepCardData?.steps || []);
    }
  }, [nextStepCardData, error]);

  useEffect(() => {
    console.log("nextStepCardLoading : ", )
  }, [nextStepCardLoading])

    if (taskStatus=="pending" && taskStatus!="failed") {  
      return(
      <div style={{display:"flex",justifyContent:"center",alignItems:"center"}}>
        <GeneratingLoader/>
      </div>)
    }

  return (
    <div className="nextstep_wrapper m-2">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="battle_card_block">

            {nextStepCardLoading === true || result === null ? (
                      <>
                        <ValueSellingFrameworkPlaceholder numberOfCards={1}  widthClass="col-md-12" numberOfLines={15} />
                      </>
                    ) : Object.keys(result).length === 0 ? (
                      <div className="no-data-message">
                         <NoDataComp
                            message="Content is being generated"
                            buttonText="Refresh"
                            onButtonClick={() =>  dispatch(fetchNextStepCardRequest({opportunityId}))}
                         />
                      </div>
                    ) : (

              <Card className="battle_card_custom">
                <Card.Header className="battle_card_header">
                  Next Steps
                </Card.Header>
                <Card.Body className="battle_card_body">
                  <div className="battle_content_block">
                    <div className="row">
                    
                      {Object.entries(result || {}).map(([key_2, rowVal]) => (
                        <div className="col-md-12 pr-0 pl-0" key={key_2}>
                          <div className="right_battle_content_block">
                            <p className="right_battle_content">
                              <div className="row">
                                <div className="col-md-2 pr-0"> <strong>Step {(parseInt(key_2)+1)}:</strong> </div>
                                <div className="col-md-10 pl-0">{rowVal}</div>
                              </div>
                              
                            </p>
                          </div>
                        </div>
                      
                    ))}

                    </div>
                  </div>
                </Card.Body>
              </Card>
                )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
